import React from 'react';

import './style.scss';

const GreenLine = ({ isDraw = false }) => {
  return (
    <div className='green-line'>
      <div className='dot'/>
      {isDraw && <div className='draw'>
        Draw
      </div>}
    </div>
  );
};

export default GreenLine;
